export const CHANGE_LOCALE = 'CHANGE_LOCALE'

/* COMMON */
export const CHANGE_DATE_START = 'CHANGE_DATE_START'
export const CHANGE_DATE_END = 'CHANGE_DATE_END'
export const CLEAR_FILTER_ALL = 'CLEAR_FILTER_ALL'

/* AUTH */
export const LOGOUT_USER = 'LOGOUT_USER'

export const CHECK_EMAIL_FETCH = 'CHECK_EMAIL_FETCH'
export const CHECK_EMAIL_FETCH_SUCCESS = 'CHECK_EMAIL_FETCH_SUCCESS'
export const CHECK_EMAIL_FETCH_FAIL = 'CHECK_EMAIL_FETCH_FAIL'

export const CHECK_TEL_FETCH = 'CHECK_TEL_FETCH'
export const CHECK_TEL_FETCH_SUCCESS = 'CHECK_TEL_FETCH_SUCCESS'
export const CHECK_TEL_FETCH_FAIL = 'CHECK_TEL_FETCH_FAIL'

/* Province */
export const PROVINCE_FETCH = 'PROVINCE_FETCH'
export const PROVINCE_FETCH_SUCCESS = 'PROVINCE_FETCH_SUCCESS'
export const PROVINCE_FETCH_FAIL = 'PROVINCE_FETCH_FAIL'

export const SUB_PROVINCE_FETCH = 'SUB_PROVINCE_FETCH'
export const SUB_PROVINCE_FETCH_SUCCESS = 'SUB_PROVINCE_FETCH_SUCCESS'
export const SUB_PROVINCE_FETCH_FAIL = 'SUB_PROVINCE_FETCH_FAIL'

export const DISTRICT_FETCH = 'DISTRICT_FETCH'
export const DISTRICT_FETCH_SUCCESS = 'DISTRICT_FETCH_SUCCESS'
export const DISTRICT_FETCH_FAIL = 'DISTRICT_FETCH_FAIL'

/* Register */
export const REGISTER_EMAIL = 'REGISTER_EMAIL'
export const REGISTER_EMAIL_SUCCESS = 'REGISTER_EMAIL_SUCCESS'
export const REGISTER_EMAIL_FAIL = 'REGISTER_EMAIL_FAIL'

export const ACTIVATE_TOKEN = 'ACTIVATE_TOKEN'
export const ACTIVATE_TOKEN_SUCCESS = 'ACTIVATE_TOKEN_SUCCESS'
export const ACTIVATE_TOKEN_FAIL = 'ACTIVATE_TOKEN_FAIL'

export const GET_TOKEN_LINE = 'GET_TOKEN_LINE'
export const GET_TOKEN_LINE_SUCCESS = 'GET_TOKEN_LINE_SUCCESS'
export const GET_TOKEN_LINE_FAIL = 'GET_TOKEN_LINE_FAIL'

export const VERIFY_TOKEN_LINE = 'VERIFY_TOKEN_LINE'
export const VERIFY_TOKEN_LINE_SUCCESS = 'VERIFY_TOKEN_LINE_SUCCESS'
export const VERIFY_TOKEN_LINE_FAIL = 'VERIFY_TOKEN_LINE_FAIL'

/* login */
export const LOGIN_USER_OTT = 'LOGIN_USER_OTT'
export const LOGIN_USER_OTT_SUCESS = 'LOGIN_USER_OTT_SUCESS'
export const LOGIN_USER_OTT__FAIL = 'LOGIN_USER_OTT__FAIL'

/* forgot password */
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL'

export const SET_PASSWORD = 'SET_PASSWORD'
export const SET_PASSWORD_SUCCESS = 'SET_PASSWORD_SUCCESS'
export const SET_PASSWORD_FAIL = 'SET_PASSWORD_FAIL'

/* member */
export const MEMBER_INFO_FETCH = 'MEMBER_INFO_FETCH'
export const MEMBER_INFO_FETCH_SUCCESS = 'MEMBER_INFO_FETCH_SUCCESS'
export const MEMBER_INFO_FETCH_FAIL = 'MEMBER_INFO_FETCH_FAIL'

export const MEMBER_CHANGE_PASS = 'MEMBER_CHANGE_PASS'
export const MEMBER_CHANGE_PASS_SUCCESS = 'MEMBER_CHANGE_PASS_SUCCESS'
export const MEMBER_CHANGE_PASS_FAIL = 'MEMBER_CHANGE_PASS_FAIL'

export const MEMBER_EDIT = 'MEMBER_EDIT'
export const MEMBER_EDIT_SUCESS = 'MEMBER_EDIT_SUCESS'
export const MEMBER_EDIT_FAIL = 'MEMBER_EDIT_FAIL'

export const FAVORITE_LIST_FETCH = 'FAVORITE_LIST_FETCH'
export const FAVORITE_LIST_FETCH_SUCESS = 'FAVORITE_LIST_FETCH_SUCESS'
export const FAVORITE_LIST_FETCH_FAIL = 'FAVORITE_LIST_FETCH_FAIL'

export const MEMBER_UPLOAD = 'MEMBER_UPLOAD'
export const MEMBER_UPLOAD_SUCESS = 'MEMBER_UPLOAD_SUCESS'
export const MEMBER_UPLOAD_FAIL = 'MEMBER_UPLOAD_FAIL'

export const MEMBER_DELETE = 'MEMBER_DELETE'
export const MEMBER_DELETE_SUCCESS = 'MEMBER_DELETE_SUCCESS'
export const MEMBER_DELETE_FAIL = 'MEMBER_DELETE_FAIL'

export const MEMBER_HISTORY_FETCH = 'MEMBER_HISTORY_FETCH'
export const MEMBER_HISTORY_FETCH_SUCCESS = 'MEMBER_HISTORY_FETCH_SUCCESS'
export const MEMBER_HISTORY_FETCH_FAIL = 'MEMBER_HISTORY_FETCH_FAIL'

export const NOTIFICATION_FETCH = 'NOTIFICATION_FETCH'
export const NOTIFICATION_FETCH_SUCCESS = 'NOTIFICATION_FETCH_SUCCESS'
export const NOTIFICATION_FETCH_FAIL = 'NOTIFICATION_FETCH_FAIL'

/* Program */
export const BANNER_FETCH = 'BANNER_FETCH'
export const BANNER_FETCH_SUCESS = 'BANNER_FETCH_SUCESS'
export const BANNER_FETCH_FAIL = 'BANNER_FETCH_FAIL'

export const BANNER_DETAIL_FETCH = 'BANNER_DETAIL_FETCH'
export const BANNER_DETAIL_FETCH_SUCESS = 'BANNER_DETAIL_FETCH_SUCESS'
export const BANNER_DETAIL_FETCH_FAIL = 'BANNER_DETAIL_FETCH_FAIL'

export const CATEGORY_FETCH = 'CATEGORY_FETCH'
export const CATEGORY_FETCH_SUCESS = 'CATEGORY_FETCH_SUCESS'
export const CATEGORY_FETCH_FAIL = 'CATEGORY_FETCH_FAIL'

export const PROGRAM_DETAIL_FETCH = 'PROGRAM_DETAIL_FETCH'
export const PROGRAM_DETAIL_FETCH_SUCESS = 'PROGRAM_DETAIL_FETCH_SUCESS'
export const PROGRAM_DETAIL_FETCH_FAIL = 'PROGRAM_DETAIL_FETCH_FAIL'

export const FAVORITE_SEND_FETCH = 'FAVORITE_SEND_FETCH'
export const FAVORITE_SEND_FETCH_SUCESS = 'FAVORITE_SEND_FETCH_SUCESS'
export const FAVORITE_SEND_FETCH_FAIL = 'FAVORITE_SEND_FETCH_FAIL'

export const SEARCH_FETCH = 'SEARCH_FETCH'
export const SEARCH_FETCH_SUCESS = 'SEARCH_FETCH_SUCESS'
export const SEARCH_FETCH_FAIL = 'SEARCH_FETCH_FAIL'

export const ALL_PROGRAM_FETCH = 'ALL_PROGRAM_FETCH'
export const ALL_PROGRAM_FETCH_SUCCESS = 'ALL_PROGRAM_FETCH_SUCCESS'
export const ALL_PROGRAM_FETCH_FAIL = 'ALL_PROGRAM_FETCH_FAIL'

export const PROGRAM_PLAY_FETCH = 'PROGRAM_PLAY_FETCH'
export const PROGRAM_PLAY_FETCH_SUCCESS = 'PROGRAM_PLAY_FETCH_SUCCESS'
export const PROGRAM_PLAY_FETCH_FAIL = 'PROGRAM_PLAY_FETCH_FAIL'

export const LIVE_FETCH = 'LIVE_FETCH'
export const LIVE_FETCH_SUCCESS = 'LIVE_FETCH_SUCCESS'
export const LIVE_FETCH_FAIL = 'LIVE_FETCH_FAIL'

export const OLD_GROUP = 'OLD_GROUP'

export const CURRENT_PLAY_FETCH = 'CURRENT_PLAY_FETCH'
export const CURRENT_PLAY_FETCH_SUCCESS = 'CURRENT_PLAY_FETCH_SUCCESS'
export const CURRENT_PLAY_FETCH_FAIL = 'CURRENT_PLAY_FETCH_FAIL'

/* setting */
export const ALL_CATEGORY_FETCH = 'ALL_CATEGORY_FETCH'
export const ALL_CATEGORY_FETCH_SUCCESS = 'ALL_CATEGORY_FETCH_SUCCESS'
export const ALL_CATEGORY_FETCH_FAIL = 'ALL_CATEGORY_FETCH_FAIL'

export const EXTERNAL_CATEGORY_FETCH = 'EXTERNAL_CATEGORY_FETCH'
export const EXTERNAL_CATEGORY_FETCH_SUCCESS = 'EXTERNAL_CATEGORY_FETCH_SUCCESS'
export const EXTERNAL_CATEGORY_FETCH_FAIL = 'EXTERNAL_CATEGORY_FETCH_FAIL'

export const ALL_SUBCATEGORY_FETCH = 'ALL_SUBCATEGORY_FETCH'
export const ALL_SUBCATEGORY_FETCH_SUCCESS = 'ALL_SUBCATEGORY_FETCH_SUCCESS'
export const ALL_SUBCATEGORY_FETCH_FAIL = 'ALL_SUBCATEGORY_FETCH_FAIL'

export const HELP_FETCH = 'HELP_FETCH'
export const HELP_FETCH_SUCCESS = 'HELP_FETCH_SUCCESS'
export const HELP_FETCH_FAIL = 'HELP_FETCH_FAIL'

export const HELP_DETAIL_FETCH = 'HELP_DETAIL_FETCH'
export const HELP_DETAIL_FETCH_SUCCESS = 'HELP_DETAIL_FETCH_SUCCESS'
export const HELP_DETAIL_FETCH_FAIL = 'HELP_DETAIL_FETCH_FAIL'

export const POLICY_LIST_FETCH = 'POLICY_LIST_FETCH'
export const POLICY_LIST_FETCH_SUCCESS = 'POLICY_LIST_FETCH_SUCCESS'
export const POLICY_LIST_FETCH_FAIL = 'POLICY_LIST_FETCH_FAIL'

export const SEARCH_HELP_LIST_FETCH = 'SEARCH_HELP_LIST_FETCH'
export const SEARCH_HELP_LIST_FETCH_SUCCESS = 'SEARCH_HELP_LIST_FETCH_SUCCESS'
export const SEARCH_HELP_LIST_FETCH_FAIL = 'SEARCH_HELP_LIST_FETCH_FAIL'


export const PROGRAM_DETAIL_PREVIEW_FETCH = 'PROGRAM_DETAIL_PREVIEW_FETCH'
export const PROGRAM_DETAIL_PREVIEW_FETCH_SUCESS = 'PROGRAM_DETAIL_PREVIEW_FETCH_SUCESS'
export const PROGRAM_DETAIL_PREVIEW_FETCH_FAIL = 'PROGRAM_DETAIL_PREVIEW_FETCH_FAIL'

export const SHARE_FETCH = 'SHARE_FETCH'
export const SHARE_FETCH_SUCESS = 'SHARE_FETCH_SUCESS'
export const SHARE_FETCH_FAIL = 'SHARE_FETCH_FAIL'


export const MEMBER_UPDATE_SHOW_NOTI = 'MEMBER_UPDATE_SHOW_NOTI'
export const MEMBER_UPDATE_SHOW_NOTI_SUCESS = 'MEMBER_UPDATE_SHOW_NOTI_SUCESS'
export const MEMBER_UPDATE_SHOW_NOTI_FAIL = 'MEMBER_UPDATE_SHOW_NOTI_FAIL'

export const GET_TOKEN_LINE_MOBILE = 'GET_TOKEN_LINE_MOBILE'
export const GET_TOKEN_LINE_MOBILE_SUCCESS = 'GET_TOKEN_LINE_MOBILE_SUCCESS'
export const GET_TOKEN_LINE_MOBILE_FAIL = 'GET_TOKEN_LINE_MOBILE_FAIL'

export const VERIFY_TOKEN_LINE_MOBILE = 'VERIFY_TOKEN_LINE_MOBILE'
export const VERIFY_TOKEN_LINE_MOBILE_SUCCESS = 'VERIFY_TOKEN_LINE_MOBILE_SUCCESS'
export const VERIFY_TOKEN_LINE_MOBILE_FAIL = 'VERIFY_TOKEN_LINE_MOBILE_FAIL'


export const CLICK_SHARE_FETCH = 'CLICK_SHARE_FETCH'
export const CLICK_SHARE_FETCH_SUCESS = 'CLICK_SHARE_FETCH_SUCESS'
export const CLICK_SHARE_FETCH_FAIL = 'CLICK_SHARE_FETCH_FAIL'


/* ---------------------------------------------------------------------- */
export * from './registeremail/actions'
export * from './auth/actions'
export * from './forgot/actions'
export * from './common/actions'
export * from './province/actions'
export * from './settings/actions'
export * from './member/actions'
export * from './program/actions'